import { APICore } from './apiCore'

const api = new APICore()

function getEnlaces (params) {
  const baseUrl = '/enlaces'
  return api.get(baseUrl, params)
}

function getEnlace (id) {
  const baseUrl = `/enlaces/${id}`
  return api.get(baseUrl, {})
}

function addEnlace (params) {
  const baseUrl = '/enlaces'
  return api.createWithFile(baseUrl, params)
}

function updateEnlace (params) {
  const baseUrl = '/enlaces'
  return api.updateWithFile(baseUrl, params)
}

function deleteEnlace (params) {
  const baseUrl = '/enlaces'
  return api.delete(baseUrl, params)
}

export { getEnlaces, getEnlace, addEnlace, updateEnlace, deleteEnlace }
